import { Box, VStack } from "@chakra-ui/react";
import { getCxIdByPatientId } from "../../api/patients";
import CustomerIdLookupForm from "./customer-lookup/CustomerIdLookupForm";

export default function ToolsPage() {
  async function handleLookup(patientId: string) {
    return await getCxIdByPatientId(patientId);
  }

  return (
    <Box>
      <VStack p={10} align="start">
        <Box w="full" maxW="4xl">
          <CustomerIdLookupForm onLookup={handleLookup} />
        </Box>
      </VStack>
    </Box>
  );
}
